var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useLocation, useNavigate } from 'react-router-dom';
import { useTimeoutFn } from 'react-use';
import { appActions } from 'app/app.actions';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
export const AnalyticsFeedbackView = () => {
    const dispatch = useAppDispatch();
    const { pathname } = useLocation();
    const navigate = useNavigate();
    // Shows the feedback modal after a short delay.
    useTimeoutFn(() => __awaiter(void 0, void 0, void 0, function* () {
        const { isSent, isCancelled } = yield dispatch(appActions.showModal({
            modal: {
                type: 'app:feedbackForm',
                arg: {
                    title: 'Analytics Feedback',
                    team: 'insights',
                },
            },
        }));
        // Whenever the feedback modal is closed, navigate back to the parent route.
        if (isSent || isCancelled) {
            navigate(pathname.replace('/feedback', ''), { replace: true });
        }
    }), 2000);
    return null;
};
